import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;

  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.palette.neutral[50]};

  button {
    min-width: 250px;
  }
`;
